import { render, staticRenderFns } from "./update-transaction-type.vue?vue&type=template&id=5fc7c1c8&scoped=true"
import script from "./update-transaction-type.vue?vue&type=script&lang=js"
export * from "./update-transaction-type.vue?vue&type=script&lang=js"
import style0 from "./update-transaction-type.vue?vue&type=style&index=0&id=5fc7c1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7c1c8",
  null
  
)

export default component.exports